import { AdSlotInterstialState } from 'mk2/containers/AdSlotInterstitial/AdSlotInterstitial.reducers';
import { AppState } from 'mk2/reducers';

export const getAdSlotInterstitialState = (state: AppState): AdSlotInterstialState =>
    state.containers.global.adSlotInterstitial;
